import AvenirNextRegularWoff from './AvenirNext-Regular.woff';
import AvenirNextRegularWoff2 from './AvenirNext-Regular.woff2';
import AvenirNextMediumWoff from './AvenirNext-Medium.woff';
import AvenirNextMediumWoff2 from './AvenirNext-Medium.woff2';
import AvenirNextDemiBoldWoff from './AvenirNext-DemiBold.woff';
import AvenirNextDemiBoldWoff2 from './AvenirNext-DemiBold.woff2';
import AvenirNextBoldWoff from './AvenirNext-Bold.woff';
import AvenirNextBoldWoff2 from './AvenirNext-Bold.woff2';

export default {
  AvenirNextRegularWoff,
  AvenirNextRegularWoff2,
  AvenirNextMediumWoff,
  AvenirNextMediumWoff2,
  AvenirNextDemiBoldWoff,
  AvenirNextDemiBoldWoff2,
  AvenirNextBoldWoff,
  AvenirNextBoldWoff2
};
